<template>
    <div class="dropup onlinebooking-language-select">
        <span id="language-switcher" data-toggle="dropdown" aria-haspopup="true">
            <i class="zmdi zmdi-globe-alt"></i>
            <span class="hidden-xs hidden-sm">{{ currentCountry.name }}</span>
            <span class="hidden-md hidden-lg uppercase">{{ currentCountry.locale }}</span>
        </span>
        <ul class="dropdown-menu" :class="{'dropdown-menu-right': isClientMobile}" aria-labelledby="language-switcher">
            <li v-for="country in countries" @click="changeCountry(country)" :key="country.key"><a href="#">{{ country.name }}</a></li>
        </ul>
    </div>
</template>

<script>
import { http } from '@/system/http.js';
import IsClientMobile from 'Components/mixins/IsClientMobile.vue';

export default {
    name: 'OnlineBookingLocaleSelector',

    mixins: [
        IsClientMobile,
    ],

    data() {
        return {
            currentLocale: Lang.locale(),
            countries: [
                { key: 'en', name: 'English', locale: Config.get('countries.en.locale') },
                { key: 'da', name: 'Dansk', locale: Config.get('countries.da.locale') },
                { key: 'se', name: 'Svenska', locale: Config.get('countries.se.locale') },
                { key: 'no', name: 'Norwegian Bokmål', locale: Config.get('countries.no.locale') },
                { key: 'fi', name: 'Suomi', locale: Config.get('countries.fi.locale') },
            ],
        };
    },

    methods: {
        changeCountry(country) {
            const newLocale = Config.get(`countries.${country.key}.locale`);

            http.post('/set-ob-locale', { country: newLocale })
                .then(() => {
                    window.location.reload();
                })
                .catch(() => {});
        },
    },

    computed: {
        currentCountry() {
            return this.countries.find(country => country.locale === this.currentLocale);
        },
    },
}
</script>

<style lang="scss">
.onlinebooking-language-select {
    cursor: pointer;
    display: inline;

    a {
        color: #58666e !important;
    }

    #language-switcher {
        color: var(--brand-primary);
    }

    #language-switcher:hover {
        color: var(--brand-primary-darkest);
    }
}
</style>
